import React from 'react';
import python from '../assets/Python.jpg';

const PythonRoadmap = () => {
  return (
    <div className="min-h-screen bg-[#0A0F20] flex flex-col items-center justify-center p-8">
      <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 text-center">
        Python Roadmap for Beginners
      </h1>
      <div className="bg-gray-800 p-4 rounded-lg shadow-lg max-w-5xl w-full">
        <img
          src={python}
          alt="Python Roadmap"
          className="w-full h-auto rounded-md transform scale-105"
        />
      </div>
    </div>
  );
};

export default PythonRoadmap;